module.exports = __webpack_public_path__ + "static/home-artist-development-mobile-fef30a75e9151902bf199eed85b4508e.png";